import { useState } from "react";

const pages = {
  Home: "#home",
  About: "#about",
  Skills: "#skills",
  Portfolio: "#portfolio",
  Contact: "#contact",
};

function AppBar() {
  const [isNavActive, setIsNavActive] = useState(false);
  const [isToggleActive, setIsToggleActive] = useState(false);
  const [isHeaderActive, setIsHeaderActive] = useState(false);

  const toggleNav = () => {
    setIsNavActive(!isNavActive);
    setIsToggleActive(!isToggleActive);
  };

  const closeNav = () => {
    setIsNavActive(false);
    setIsToggleActive(false);
  };

  const handleScroll = () => {
    if (window.scrollY >= 100) {
      setIsHeaderActive(true);
    } else {
      setIsHeaderActive(false);
    }
  };
  window.addEventListener("scroll", handleScroll);

  return (
    <>
      <header
        className={
          isHeaderActive
            ? `header active ${isNavActive ? "nav-active" : ""}`
            : `header ${isNavActive ? "nav-active" : ""} `
        }
        data-header
      >
        <div className="container">
          <a href="#home">
            <h1 className="logo">Yuvaraja D</h1>
          </a>

          <button
            className={isNavActive ? "nav-toggle-btn active" : "nav-toggle-btn"}
            aria-label="Toggle Menu"
            data-nav-toggle-btn
            onClick={toggleNav}
          >
            <ion-icon name="menu-outline" className="menu-icon"></ion-icon>
            <ion-icon name="close-outline" className="close-icon"></ion-icon>
          </button>

          <nav className="navbar container">
            <ul className="navbar-list">
              {Object.keys(pages).map((key) => (
                <li key={key}>
                  <a
                    href={pages[key]}
                    className="navbar-link"
                    data-nav-link
                    onClick={closeNav}
                  >
                    {key}
                  </a>
                </li>
              ))}
              <li>
                <a href="#download" className="btn btn-primary">
                  Download CV
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      <a
        href="#top"
        className={isHeaderActive ? "back-to-top active" : "back-to-top"}
        data-back-to-top
      >
        BACK TOP
      </a>
    </>
  );
}
export default AppBar;
